<div class="row">
  <div class="col-lg-12">
    <div class="pro-right-col blockdiv">
      <div class="row pip-title">
        <div class="col-12">
          <h2><img src="../../../../../assets/images/icons/overview.svg" style="margin-top: -3px;"/>
            &nbsp;
            <span *ngIf="activeLang === 'en'">Overview - {{'MY_ACCOUNT.BUYING' | translate}}</span>
            <span *ngIf="activeLang === 'si'">දළ විශ්ලේෂණය - {{'MY_ACCOUNT.BUYING' | translate}}</span>
            <span *ngIf="activeLang === 'ta'">கண்ணோட்டம் - {{'MY_ACCOUNT.BUYING' | translate}}</span></h2>
        </div>
        <div class="col-12">
          <div class="separator">&nbsp;</div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div class="pic-main-wp">
            <div class="row">
              <div class="col-md-4">
                <a href="javascript:void(0)">
                  <div class="pic-wp-2 background" [routerLink]="'/my-account/purchases/wholesale'">
                    <h6 *ngIf="activeLang === 'en'">Total Purchases</h6>
                    <h6 *ngIf="activeLang === 'si'">මුළු මිලදී ගැනීම්</h6>
                    <h6 *ngIf="activeLang === 'ta'">மொத்த கொள்முதல்</h6>
                    <span style="font-size: 20px">{{dashboardDetails?.totalPurchase}}</span>
                  </div>
                </a>
              </div>
              <div class="col-md-4">
                <a href="javascript:void(0)">
                  <div class="pic-wp-2 background" [routerLink]="'/my-account/purchases/wholesale'">
                    <h6 *ngIf="activeLang === 'en'">Purchases Spot Products</h6>
                    <h6 *ngIf="activeLang === 'si'">මිලදී ගත් ක්ෂණික නිෂ්පාදන</h6>
                    <h6 *ngIf="activeLang === 'ta'">ஸ்பாட் தயாரிப்புகள் வாங்கப்பட்டன</h6>
                    <span style="font-size: 20px">{{dashboardDetails?.spotPurchased}}</span>
                  </div>
                </a>
              </div>
              <div class="col-md-4">
                <a href="javascript:void(0)">
                  <div class="pic-wp-2 background" [routerLink]="'/my-account/purchases/wholesale'">
                    <h6 *ngIf="activeLang === 'en'">Purchases Auction Products</h6>
                    <h6 *ngIf="activeLang === 'si'">මිලදී ගත් වෙන්දේසි නිෂ්පාදන</h6>
                    <h6 *ngIf="activeLang === 'ta'">ஏல பொருட்கள் வாங்கப்பட்டது</h6>
                    <span style="font-size: 20px">{{dashboardDetails?.auctionPurchased}}</span>
                  </div>
                </a>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="separator">&nbsp;</div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 col-lg-3" *ngFor="let purchaseDetails of dashboardDetails?.purchaseList">
          <div class="ovps-box" style="padding: 10px;cursor: pointer" [routerLink]="'/my-account/purchases/wholesale'"
               [queryParams]="{id:purchaseDetails.id}">
            <div class="onpc-img">
              <img *ngIf="purchaseDetails?.productImage !== null" alt="" src="{{this.mainUrl.MAIN_URL_FILE +
                            purchaseDetails?.productImage + '/?X-TenantID=wholesale'}}"
                   style="border-radius: 10px;width:50px; height: 50px;object-fit: cover;"/>
              <img *ngIf="purchaseDetails?.productImage === null"
                   src="assets/defaultBrokenImage.jpg" alt=""
                   style="border-radius: 10px;width:50px; height: 50px;object-fit: cover;"/>
            </div>
            <div class="details">
              <span>{{purchaseDetails?.transactionId}}</span>
              <h6>{{purchaseDetails?.productName}}</h6>
              <span>{{convertDate(purchaseDetails?.created)}}</span>
              <span class="price">+ {{purchaseDetails?.price | number:'2.2-2'}}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 text-right">

          <h6 *ngIf="activeLang === 'en'" class="oetw-label">Purchases this week: <span
            style="font-size: 20px"> {{'CURRENCY.CURRENCY' | translate}}&nbsp; {{dashboardDetails?.weekPurchased | number:'2.2-2'}}</span>
          </h6>

          <h6 *ngIf="activeLang === 'si'" class="oetw-label">මෙම සතියේ මිලදී ගැනීම්: <span
            style="font-size: 20px"> {{'CURRENCY.CURRENCY' | translate}}&nbsp; {{dashboardDetails?.weekPurchased | number:'2.2-2'}}</span>
          </h6>

          <h6 *ngIf="activeLang === 'ta'" class="oetw-label">இந்த வாரம் வாங்குகிறது: <span
            style="font-size: 20px"> {{'CURRENCY.CURRENCY' | translate}}&nbsp; {{dashboardDetails?.weekPurchased | number:'2.2-2'}}</span>
          </h6>

        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="separator" style="margin: 25px 0;">&nbsp;</div>
        </div>
      </div>

      <div class="row">
        <div class="col-8">
          <h4 *ngIf="activeLang === 'en'">New Products</h4>
          <h4 *ngIf="activeLang === 'si'">නව නිෂ්පාදන</h4>
          <h4 *ngIf="activeLang === 'ta'">புதிய தயாரிப்புகள்</h4>
        </div>
        <div class="col-4 text-right">
          <a [routerLink]="'/products/wholesale'">
            <span *ngIf="activeLang === 'en'">View All</span>
            <span *ngIf="activeLang === 'si'">සියල්ල බලන්න</span>
            <span *ngIf="activeLang === 'ta'">அனைத்தையும் காட்டு</span>
            <i aria-hidden="true" class="fa fa-long-arrow-right"></i></a>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-4 col-md-12" *ngFor="let products of dashboardDetails?.productDTOS">
          <div style="cursor: pointer" class="onp-cart" [routerLink]="['/product-view-spot/wholesale']"
               [queryParams]="{id:products.id,typeId:1,typeName:'SPOT'}">
            <div class="onpc-img">
              <img *ngIf="products?.image !== null" alt="" src="{{this.mainUrl.MAIN_URL_FILE +
                            products?.image + '/?X-TenantID=wholesale'}}"
                   style="border-radius: 10px;width:50px; height: 50px;object-fit: cover;"/>
              <img *ngIf="products?.image === null"
                   src="assets/defaultBrokenImage.jpg" alt=""
                   style="border-radius: 10px;width:50px; height: 50px;object-fit: cover;"/>
            </div>
            <div class="onpc-detail">
              <h6>{{products?.productName}}</h6>
              <span>
                                <span>
                                    {{'CURRENCY.CURRENCY' | translate}}&nbsp;{{products?.unitPrice}}
                                </span>
                            </span>
            </div>
            <div class="link">
              <i aria-hidden="true" class="fa fa-chevron-right"></i>
            </div>
          </div>
        </div>
      </div>


      <div class="row">
        <div class="col-12">
          <div class="separator" style="margin: 10px 0 25px 0;">&nbsp;</div>
        </div>
      </div>

      <div class="row">
        <div class="col-8">
          <h4 *ngIf="activeLang === 'en'">Review</h4>
          <h4 *ngIf="activeLang === 'si'">සමාලෝචනය</h4>
          <h4 *ngIf="activeLang === 'ta'">விமர்சனம்</h4>
        </div>
        <div class="col-4 text-right">
          <a [routerLink]="'/my-account/reviews/wholesale'">
            <span *ngIf="activeLang === 'en'">View All</span>
            <span *ngIf="activeLang === 'si'">සියල්ල බලන්න</span>
            <span *ngIf="activeLang === 'ta'">அனைத்தையும் காட்டு</span>
            <i aria-hidden="true" class="fa fa-long-arrow-right"></i></a>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-6" *ngFor="let review of dashboardDetails?.reviewDTOS">
          <div class="o-review-cart">
            <div class="row">
              <div class="col-8">
                <dl class="orp-info">
                  <dt>
                    <img *ngIf="review?.imgUrl !== null && review?.imgUrl !== undefined" alt="" src="{{this.mainUrl.MAIN_URL_FILE +
                            review?.imgUrl + '/?X-TenantID=wholesale'}}"
                         style="width: 70px; height: 70px">
                    <img *ngIf="review?.imgUrl === null || review?.imgUrl === undefined" alt="" src="assets/avatar.jpg"
                         style="width: 70px; height: 70px">
                  </dt>
                  <dd>
                    <span>{{review?.reviewedBy}}</span>
                    <star-rating checkedcolor="#FFA84C" readonly="true" size="20px" totalstars="5"
                                 uncheckedcolor="#999999" value="{{review?.rating}}"></star-rating>
                  </dd>
                </dl>
              </div>
              <div class="col-4 text-right">
                <span class="date">{{convertDate(review?.created)}}</span>
              </div>
              <div class="col-12">
                <p>{{review?.comment}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

